<template>
  <div id="container" class="cs_st grid-container">
    <!-- Location START -->

    <!-- TODO: Should use Subbar component -->
    <BaseLocation current-group-name="information" />
    <!-- Location END -->
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div class="section terms_wrap" v-html="privacy"></div>
    <!-- <transition name="slide-right"> -->
    <Sidebar />
    <!-- </transition> -->
  </div>
</template>

<script>
import axios from '@/store/axios'
import { mapGetters } from 'vuex'
import { UI_SHOW_SIDEBAR } from '@/store/types'
export default {
  name: 'Privacy',
  data() {
    return {
      showListMenu: false,
      privacy: ''
    }
  },
  computed: {
    ...mapGetters(['isSidebarOpen'])
  },
  async mounted() {
    const response = await axios.get('/authenticate/MEMBER/terms/')
    this.privacy = response.data.result.storeTerms.collectAndUse
  },
  methods: {
    openSidebar() {
      this.$store.commit(UI_SHOW_SIDEBAR)
    },
    closeListMenu() {
      this.showListMenu = false
    },
    toggleListMenu() {
      this.showListMenu = !this.showListMenu
    }
  }
}
</script>
<style src="@/assets/css/page_customer.css" scoped></style>
